"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.button.start': 'Inizia onboarding',
    'onboarding.button.continue': 'Continua ai Passi',
    'onboarding.button.previous': 'Precedente',
    'onboarding.button.next': 'Successivo',
    'onboarding.button.complete': 'Completa Onboarding',
};
